import { Button, Divider, InputNumber, Space } from 'antd';
import React, { useState, useEffect } from 'react';
import { FilterActionsWrapper, FilterOptionsWrapper } from 'ui/Filter';
import { thousandFormatter } from 'utils/forms/formatter';

function SumRange({ fromValue, toValue, getRange }) {
  const [sumFrom, setSumFrom] = useState(undefined);
  const [sumTo, setSumTo] = useState(undefined);
  const canReset = sumFrom || sumTo;

  useEffect(() => {
    setSumFrom(fromValue);
    setSumTo(toValue);
  }, [fromValue, toValue]);

  const handleFilter = () => {
    if (sumFrom !== undefined || sumTo !== undefined) {
      getRange(sumFrom, sumTo);
    }
  };

  const handleClear = () => {
    setSumFrom(null);
    setSumTo(null);
    getRange(null, null);
  };

  return (
    <>
      <FilterOptionsWrapper>
        <Space direction="vertical">
          <InputNumber
            value={sumFrom}
            placeholder="Сумма от"
            controls={false}
            formatter={thousandFormatter}
            onChange={(val) => setSumFrom(val)}
            onPressEnter={handleFilter}
            style={{ width: '120px' }}
          />
          <InputNumber
            value={sumTo}
            placeholder="Сумма до"
            controls={false}
            formatter={thousandFormatter}
            onChange={(val) => setSumTo(val)}
            onPressEnter={handleFilter}
            style={{ width: '120px' }}
          />
        </Space>
      </FilterOptionsWrapper>

      <Divider style={{ margin: 0 }} />

      <FilterActionsWrapper>
        <Space>
          <Button
            type="link"
            size="small"
            onClick={handleClear}
            disabled={!canReset}
          >
            Сбросить
          </Button>
          <Button type="primary" size="small" onClick={handleFilter}>
            ОК
          </Button>
        </Space>
      </FilterActionsWrapper>
    </>
  );
}

export { SumRange };
